import marker from '../../../assets/marker1.svg'
import clouds from '../../../assets/clouds.svg'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store'

export default function LocationIndicator() {
  const locationName = useSelector(
    (state: RootState) => state.user.defaultLocation?.name
  )
  const [showLocation, setShowLocation] = useState(true)
  const [showDate, setShowDate] = useState(true)
  const month = [
    'Jan',
    'Feb',
    'Mar',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ]
  const date = new Date()
  const dateString = `${date.toLocaleDateString().split('/')[1]} ${
    month[date.getMonth()]
  } ${date.toLocaleDateString().split('/')[2]}`

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth

      if (windowWidth <= 1000) {
        setShowDate(false)
      } else {
        setShowDate(true)
      }
    }
    // Add the event listener when the component mounts
    window.addEventListener('resize', handleResize)

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  },[])

  return (
    <div className={showDate ? "relative box-border w-96 self-center basis-11 grow-0 shrink-0":"relative box-border w-64 self-center basis-11 grow-0 shrink-0"}>
      <div
        className={showDate ? "flex flex-row w-96 h-11 bg-gray-100 justify-between items-center" : "flex flex-row w-64 h-11  bg-gray-100 justify-between items-center"}
        style={{ borderRadius: '25px' }}
      >
        <img
          className="flex flex-1 w-6 h-6"
          src={marker}
          alt=""
        />
        {locationName && (
          <div
            className={`text-xl font-semibold text-[#1e293b] whitespace-nowrap flex-1`}
            style={{
              maxWidth: '60%',
            }}
          >
            {locationName.length > 10
              ? `${locationName.slice(0, 10)}...`
              : locationName}
          </div>
        )}
        {showDate && <div className="flex-1 no-wrap text-base text-[#1e293b]">{dateString}</div>}
        <img className="h-6 flex-1" src={clouds} alt="" />
      </div>
    </div>
  )
}
